module.exports = __webpack_public_path__ + "img/hong.6e3f7e8a.png";